import Identified from "@mapmycustomers/shared/types/base/Identified";
import { EntityType, EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import { mapEntityIdParser } from "@app/util/map/idParsers";

// The request's filters narrowed to the lasso's selected records; the input is left untouched.
const withLassoIds = (
  filters: PlatformFilterModel,
  selectedRecords: Set<string>,
  visibleEntities: EntityTypesSupportedByMapsPage[]
): PlatformFilterModel => {
  if (!filters.entities || Array.isArray(filters.entities)) {
    return filters;
  }

  const idsByType: Record<EntityTypesSupportedByMapsPage, Array<Identified["id"]>> = {
    [EntityType.COMPANY]: [],
    [EntityType.DEAL]: [],
    [EntityType.PERSON]: [],
  };
  for (const mapEntityId of selectedRecords.values()) {
    const parsed = mapEntityIdParser(mapEntityId);
    if (parsed) {
      idsByType[parsed.entity as EntityTypesSupportedByMapsPage].push(parsed.id);
    }
  }

  const entities = filters.entities as Record<EntityTypesSupportedByMapsPage, PlatformFilterModel>;
  const entitiesWithIds = { ...entities };
  (Object.keys(entities) as EntityTypesSupportedByMapsPage[]).forEach((entityKey) => {
    const andCondition = entities[entityKey].$and ?? [];
    // A non-array $and can't take the ids, so that type is sent as it was.
    if (visibleEntities.includes(entityKey) && Array.isArray(andCondition)) {
      entitiesWithIds[entityKey] = {
        ...entities[entityKey],
        $and: [...andCondition, { id: { $in: idsByType[entityKey] } }],
      };
    }
  });

  return { ...filters, entities: entitiesWithIds };
};

export default withLassoIds;
